import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Button,
  Checkbox,
  Grid,
  Typography,
  Autocomplete,
  Pagination,
  Skeleton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import TablePagination from "@mui/material/TablePagination";
import { dashboardStyle } from "../../Invoices/Components/InvoiceDetails/style";
import { FormatAmount } from "../FormatAmount";
import moment from "moment";
import * as XLSX from "xlsx";
import axios from "axios";
import { ArrowUpward, ArrowDownward } from "@material-ui/icons";
import ApsTable from "./ApsTable";
import InvoicePaidAfterDue from "../InvoicePaidAfterDue";
import InvoiceStatus from "../InvoiceStatus";
import { ArrowBack, Error } from "@mui/icons-material";
import { IconButton } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { logDOM } from "@testing-library/react";
import { handleInvoiceClick } from "../CommonLink";

const useStyles = makeStyles(dashboardStyle);

const FormatDate = (dateString) => {
  if (!dateString) return null;
  const parsedDate = moment(dateString);
  const formattedDate = parsedDate.format("DD MMM YYYY");
  return formattedDate;
};

const defaultFormValues = {
  RowsOfPage: 25,
  PageNo: 1,
  venderName: "All",
  statusFilter: "All",
  PendingWith: "All",
  PhoneNumber: "All",
  startDate: undefined,
  endDate: undefined,
  sortColumn: undefined,
  invoiceNoFilter: undefined,
  isAsc: false,
};
const defaultFormValuesDownload = {
  venderName: undefined,
  statusFilter: undefined,
  PendingWith: undefined,
  PhoneNumber: undefined,
  startDate: undefined,
  endDate: undefined,
  sortColumn: undefined,
  isAsc: false,
  isPdf: false,
};
const PoTable = ({
  header,
  dropdownValue,
  loading,
  setComplianceDates , 
  setData,
  setLoading,
  data,
  page,
}) => {
  console.log("dataList", data);
  const [filteredData, setFilteredData] = useState(data);
  const classes = useStyles();
  const [count, setCount] = useState(0);
  const navigate = useNavigate();

  const [formState, setFormState] = useState(
    defaultFormValues || defaultFormValuesDownload
  );

  useEffect(()=>{
setComplianceDates({
  startDate : formState?.startDate, 
  endDate : formState?.endDate
})
  },[formState?.startDate , formState?.endDate])
  const fetchData = async (params) => {
    setLoading(true);

    try {
      console.log("params", {
        fromDate: params.startDate,
        toDate: params.endDate,
      });
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/Report/GetInvoicesRatio`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
          params: {
            fromDate: params.startDate,
            toDate: params.endDate,
          },
        }
      );
      console.log("res:", res);
      setData(res?.data?.response);
      setCount(res?.data?.totalCount);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const resetFilter = async () => {
    setFormState(defaultFormValues);
    await fetchData(defaultFormValues);
  };
  console.log("latest", data);
  const [userList, setUserList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  useEffect(() => {
    fetchData(formState);
  }, [
    formState?.PageNo,
    formState?.RowsOfPage,
    formState.sortColumn,
    formState.isAsc,
  ]);

  const fetchUserList = async (query) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/getVendorDetails/${query ? query : null
        }`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("user_token")}`,
          },
        }
      );
      setUserList(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (searchQuery.trim() !== "") {
      fetchUserList(searchQuery);
    } else {
      fetchUserList();
    }
  }, [searchQuery]);
  return (
    <div style={{ height: "500px" }}>
      <Grid
        container
        justifyContent="space-between"
        style={{
          padding: "1px 27px",
          backgroundColor: "#031C30",
          color: "white",
          height: "62px",
        }}
      >
        <Grid item xs={6} sm={6} md={6} lg={6}>
          <h4>Compilance Report </h4>
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6}>
          <IconButton
            variant="contained"
            style={{ float: "right", marginTop: "1.5%" }}
            onClick={() => navigate("/home")}
          >
            <ArrowBack style={{ color: "#fff" }} titleAccess="Go Back" />
          </IconButton>
        </Grid>
      </Grid>
      <Grid container spacing={2} mt={0} mb={5}>
        <Grid item xs={12} sm={12} md={2} lg={2}>
          <Typography>
            Start Date:
          </Typography>
          <TextField
            type="date"
            variant="outlined"
            fullWidth
            size="small"
            value={formState.startDate || ""}
            onChange={(e) => {
              setFormState((x) => ({
                ...x,
                startDate: e.target.value,
              }));
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={2} lg={2}>
          <Typography>
            End Date:
          </Typography>
          <TextField
            fullWidth
            size="small"
            type="date"
            variant="outlined"
            value={formState.endDate || ""}
            onChange={(e) => {
              setFormState((x) => ({
                ...x,
                endDate: e.target.value,
              }));
            }}
            InputLabelProps={{
              shrink: true,
            }}
            style={{ marginRight: "10px" }}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={8} lg={8}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>
              <Button
                variant="contained"
                style={{
                  width: "150px",
                  height: "45px",
                  margin: "12px",
                  pointer: "cursor",
                }}
                color="primary"
                onClick={() => fetchData(formState)}
              >
                Filter
              </Button>
              <Button
                variant="contained"
                style={{
                  width: "150px",
                  height: "45px",
                  margin: "12px",
                  pointer: "cursor",
                }}
                color="primary"
                onClick={resetFilter}
              >
                Reset Filter
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>

      <div style={{ display: "flex", justifyContent: "left" }}>
        {!data ? (
          <Skeleton
            variant="rectangular"
            style={{ height: 48, marginBottom: "10px" }}
          />
        ) : (
          <Table style={{ width: "800px" }}>
            <TableBody>
              <TableRow>
                <TableCell style={{ backgroundColor: "#EFF2F4" }} ></TableCell>
                <TableCell style={{ backgroundColor: "#EFF2F4" }}>
                  PO Based payments
                </TableCell>
                <TableCell style={{ backgroundColor: "#EFF2F4" }}>
                  NON-PO based payments
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ backgroundColor: "#EFF2F4" }}>No of Invoice</TableCell>
                <TableCell>{data[0]?.poInvoicesCount}</TableCell>
                <TableCell>{data[0]?.nonPOInvoicesCount}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ backgroundColor: "#EFF2F4" }}>Amount</TableCell>
                <TableCell>{FormatAmount(data[0]?.poInvoicesAmount)}</TableCell>
                <TableCell>
                  {FormatAmount(data[0]?.nonPOInvoicesAmount)}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ backgroundColor: "#EFF2F4" }}>% age of total</TableCell>
                <TableCell>
                  {(
                    (data[0]?.poInvoicesAmount /
                      (data[0]?.nonPOInvoicesAmount +
                        data[0]?.poInvoicesAmount)) *
                    100
                  ).toFixed(2) == "Infinity"
                    ? "0"
                    : (
                      (data[0]?.poInvoicesAmount /
                        (data[0]?.nonPOInvoicesAmount +
                          data[0]?.poInvoicesAmount)) *
                      100
                    ).toFixed(2)}
                </TableCell>
                <TableCell>
                  {" "}
                  {(
                    (data[0]?.nonPOInvoicesAmount /
                      (data[0]?.nonPOInvoicesAmount +
                        data[0]?.poInvoicesAmount)) *
                    100
                  ).toFixed(2) == "Infinity"
                    ? "0"
                    : (
                      (data[0]?.nonPOInvoicesAmount /
                        (data[0]?.nonPOInvoicesAmount +
                          data[0]?.poInvoicesAmount)) *
                      100
                    ).toFixed(2)}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        )}
      </div>
    </div>
  );
};

export default PoTable;
